import React, { useEffect, useState } from 'react';
import Template from '../../../components/organisms/Template';
import { Row, Col, Form } from 'react-bootstrap';
import InputText from '../../../components/atoms/InputText';
import InputTextArea from '../../../components/atoms/InputTextArea';
import InputDate from '../../../components/atoms/InputDate';
import Session from '../../../components/atoms/Session';
import { getReminder, editReminder } from '../../../services/Reminders';
import { getIdFromUrlLocationPathname, formatDateTime } from '../../../helpers/functions';
import useForm from '../../../helpers/formHelper';
import ButtonSubmit from '../../../components/atoms/ButtonSubmit';
import ButtonBar from '../../../components/molecules/ButtonBar';
import { useAlert } from 'react-alert';
import PageHeader from '../../../components/molecules/PageHeader';

function Edit(props) {

  const [loading, setLoading] = useState(true);
  const alert = useAlert();

  const [data, setData] = useState();
  const [validated, setValidated] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);

  const { inputs, handleInputChange, setInputs, validateInputs } = useForm();

  const id = getIdFromUrlLocationPathname(props.history.location.pathname);

  const addValidationError = (validationError) => {
    let validationsError = validationErrors.slice();
    validationsError.push(validationError);
    setValidationErrors(validationsError);
  }

  const edit = async () => {
    setLoading(true);
    const response = await editReminder(id, {
      data: data,
      nota: inputs.nota
    }, alert, addValidationError);

    if (response) {
      props.history.push(`/reminder/detail/${id}`);
      alert.success('Lembrete editado com sucesso');
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const result = await getReminder(id, alert);
      if (result) {
        setInputs({ ...result });
      }
      if (result && result.data) {
        setData(new Date(result.data));
      }
      setLoading(false);
    };

    fetchData();
  }, [id, setInputs]);

  const handleSubmit = event => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      const errors = validateInputs({ page: 'editReminder', data });
      if (errors && errors.length > 0) {
        event.stopPropagation();
        setValidationErrors(errors);
      } else {
        edit();
      }
    }

    setValidated(true);
  };

  return (
    <Template validationErrors={validationErrors} clearErrosFunc={() => setValidationErrors([])}
      loading={loading}>
      <PageHeader tittle="Editar Lembrete" />
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row>
          <Col>
            <InputDate id="data" name="Data" value={data || ''}
              onChange={date => setData(date)} required />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputTextArea id="nota" name="Notas" value={inputs.nota || ''}
              onChange={handleInputChange} />
          </Col>
        </Row>
        <Session name="Informações">
          <Row>
            <Col>
              <InputText name="Criado Por" value={inputs?.responsavel?.nome || ''} disabled />
            </Col>
            <Col>
              <InputText name="Data Criação"
                value={inputs.dataHoraCriacao ? formatDateTime(inputs.dataHoraCriacao) : ''} disabled />
            </Col>
          </Row>
        </Session>
        <ButtonBar>
          <ButtonSubmit variant="success" type="submit">Salvar</ButtonSubmit>
        </ButtonBar>
      </Form>
    </Template>
  );
}

export default Edit;